import {
    cancelPreliminarySession as cancelPreliminarySessionService
} from '../../../services/api/checkout';
import types from './types';

export const setPreliminarySession = payload => ({
    type: types.SET_PRELIMINARY_SESSION,
    payload
});

// TODO Think of naming, we have a few functions with the same name (service, routes.js)
export const cancelPreliminarySession = (id) => (dispatch) => {
    dispatch({
        type: types.CANCEL_PRELIMINARY_SESSION.REQUEST
    });

    // TODO Check this carefully, there was no `return` so
    // it was not working properly in any cases where
    // await cancelPreliminarySessionService was used
    return cancelPreliminarySessionService(id)
        .then(result => {
            dispatch({
                type: types.CANCEL_PRELIMINARY_SESSION.SUCCESS,
                payload: result
            });

            return Promise.resolve(result);
        })
        .catch(error => {
            dispatch({
                type: types.CANCEL_PRELIMINARY_SESSION.ERROR
            });

            // TODO Get rid of Promise.reject inside
            return Promise.reject(error);
        });
};
